import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=51e0c2c9&scoped=true"
import script from "./failed.vue?vue&type=script&lang=js"
export * from "./failed.vue?vue&type=script&lang=js"
import style0 from "./failed.vue?vue&type=style&index=0&id=51e0c2c9&prod&lang=less"
import style1 from "./failed.vue?vue&type=style&index=1&id=51e0c2c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e0c2c9",
  null
  
)

export default component.exports